import * as ko from "knockout";
import entityBase from "entityBase";
import { CustomObservables } from "app/custom-observables";
import { request_dto } from "../request/request_dto";

// dto used for solution comments
export class solution_request extends entityBase {
  solution_id: KnockoutObservable<string>;
  comments: KnockoutObservable<string>;
  ranking: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;

  request: KnockoutObservable<request_dto>;

  constructor(item?: any) {
    super();
    this.solution_id = ko.observable(item?.solution_id);
    this.comments = ko.observable(item?.comments);
    this.ranking = ko.observable(item?.ranking);
    this.created_by = ko.observable(item?.created_by);
    this.created_dttm = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);

    this.request = ko.observable();
    if (item?.request) {
      this.request = <KnockoutObservable<request_dto>>this.loadRelation(item, request_dto, "request");
    }
  }
}
